import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const activateWorkflowTemplateVersion = async (
  workflowTemplateId: string,
  workflowTemplateVersionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/${workflowTemplateId}/version/${workflowTemplateVersionId}/activate`,
    {
      method: 'POST',
    }
  );
  return res;
};
